<ion-header>
    <ion-toolbar color="secondary">
        <ion-title>Photo</ion-title>
        <ion-buttons slot="end">
            <ion-button (click)="onRotateLeft()">
                <i class="material-symbols-outlined">rotate_left</i>
            </ion-button>
            <ion-button (click)="onRotateRight()">
                <i class="material-symbols-outlined">rotate_right</i>
            </ion-button>
            <ion-button (click)="onClose()">
                <i class="material-symbols-outlined">close</i>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>
<ion-content fullscreen>
    <main class="center">
        <div class="zoom">
            <ion-img [src]="photo" [style.transform]="transform"></ion-img>
        </div>
    </main>
</ion-content>
